import { render, staticRenderFns } from "./addChart.vue?vue&type=template&id=1ff4ec16&scoped=true&"
import script from "./addChart.vue?vue&type=script&lang=js&"
export * from "./addChart.vue?vue&type=script&lang=js&"
import style0 from "./addChart.vue?vue&type=style&index=0&id=1ff4ec16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4ec16",
  null
  
)

export default component.exports